import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import {
  Card,
  Col,
  Row,
  Button,
  Tab,
  Nav,
  Table,
} from "react-bootstrap";
import Piechart from "./Piechart";
import DashboardHeader from "./directives/DashboardHeader";
import "./css/projectoverview.css";
import { getProjectDetailsAction } from "../../apis/apiAction";
import { Link, useParams } from "react-router-dom";
import config from "../../config/config";

const ProjectOverview = ({ special, clearModalData }) => {
  const { id } = useParams();
  const [projectDetails, setProjectDetail] = useState([]);
  const [tokenomicsData, setTokenomicsData] = useState([]);

  useEffect(() => {
    if (id) {
      getProjectDetailsAPI(atob(id));
    }
  }, []);

  const getProjectDetailsAPI = async (id) => {
    let res = await getProjectDetailsAction(id);
    if (res.status) {
      setProjectDetail(res.data);

      const data = [
        { detail: "Private Sale", percentage: res.data?.privateSalePercentage, quantity: res.data?.privateSalePercentage ? parseFloat(res.data.totalSupply) * res.data?.privateSalePercentage / 100 : 0 },
        { detail: "Pre Sale", percentage: res.data?.preSalePercentage, quantity: res.data?.preSalePercentage ? parseFloat(res.data.totalSupply) * res.data?.preSalePercentage / 100 : 0 },
        { detail: "Public Sale", percentage: res.data?.publicSalePercentage, quantity: res.data?.publicSalePercentage ? parseFloat(res.data.totalSupply) * res.data?.publicSalePercentage / 100 : 0 },
        { detail: "Other", percentage: res.data?.otherPercentage, quantity: res.data?.otherPercentage ? parseFloat(res.data.totalSupply) * res.data?.otherPercentage / 100 : 0 },
      ];
      setTokenomicsData(data)
    }
  };

  return (
    <>
      <div
        className="w-100 d-grid"
        style={{ minHeight: "100vh", overflow: "hidden" }}
      >
        <div className="d-flex  w-100 h-100">
          <div
            className="position-relative"
            style={{ borderRight: "1px solid rgba(255, 255, 255, 0.15)" }}
          >
            <Sidebar special={special} clearModalData={clearModalData} />
          </div>

          <div className="w-100" style={{ height: "100%" }}>
            <DashboardHeader />
            <div className="subheader mt-0">
              <img
                src="assets/images/dashboard/banner/innerbanner.svg"
                className="w-100 h-100 object-fit-cover"
              />
            </div>
            <div
              className="px-4 px-lg-4"
              style={{
                flex: "1",
                backgroundColor: "#00021F",
                color: "#ffffff",
                height: "100%",
                overflowY: "auto",
              }}
            >
              <Row className="">
                <Col xxl={12}>
                  <div className="heading py-4">
                    <h4 className="mb-0">{projectDetails?.tokenName}({projectDetails?.tokenSymbol})</h4>
                    <div className="text-white fw-normal">
                      {projectDetails?.chainList?.chainName}
                    </div>
                  </div>
                </Col>
                <Col xxl={8} xl={8} className="mb-4">
                  <Card className="dashboard-card d-flex overflow-hidden gap-3 bg-grey">
                    <div className="tabStyle3">
                      <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="projectoverview"
                      >
                        <Row>
                          <Col sm={12} className="mb-1">
                            <Nav variant="pills" className="">
                              <Nav.Item className="w-50 text-center">
                                <Nav.Link
                                  eventKey="projectoverview"
                                  className="me-0"
                                >
                                  Project Overview
                                </Nav.Link>
                              </Nav.Item>
                              <Nav.Item className="w-50 text-center">
                                <Nav.Link
                                  eventKey="tokenomics"
                                  className="me-0"
                                >
                                  Tokenomics
                                </Nav.Link>
                              </Nav.Item>
                            </Nav>
                          </Col>
                          <Col sm={12}>
                            <Tab.Content>
                              <Tab.Pane eventKey="projectoverview">
                                <Card.Body className="position-relative">
                                  <div className="d-flex justify-content-between">
                                    <div>
                                      <div className="text-light-grey small">
                                        Total Raise
                                      </div>
                                      <div className="text-white small">
                                        ${projectDetails?.usdtToRaise}
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        Duration
                                      </div>
                                      <div className="text-white small">
                                        {projectDetails?.duration}
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        ROI
                                      </div>
                                      <div className="text-white small">
                                        {projectDetails?.promisedRoi}%
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        Token Discount
                                      </div>
                                      <div className="text-white small">
                                        ${projectDetails?.tokenDiscount}
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        Total Supply
                                      </div>
                                      <div className="text-white small">
                                        {projectDetails?.totalSupply}
                                      </div>
                                    </div>
                                  </div>
                                </Card.Body>
                                <hr className="my-1" />
                                <Card.Body className="position-relative">
                                  <div>
                                    <h6 className="text-white">Summary</h6>
                                    <p className="text-light-grey fw-light">
                                      {projectDetails?.description}
                                    </p>
                                  </div>

                                  <div className="">
                                    <Link to={`${config.imageUrl}/${projectDetails?.whitepaper}`} target="_blank">
                                      <Button
                                        variant="primary-gradient"
                                        className=" border-0 px-4 small"
                                      >
                                        View Whitepaper
                                      </Button>
                                    </Link>
                                  </div>
                                </Card.Body>
                              </Tab.Pane>
                              <Tab.Pane eventKey="tokenomics">
                                <Card.Body className="position-relative">
                                  <div className="d-flex justify-content-between">
                                    <div>
                                      <div className="text-light-grey small">
                                        Total Raise
                                      </div>
                                      <div className="text-white small">
                                        ${projectDetails?.usdtToRaise}
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        Duration
                                      </div>
                                      <div className="text-white small">
                                        {projectDetails?.duration}
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        ROI
                                      </div>
                                      <div className="text-white small">
                                        {projectDetails?.promisedRoi}%
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        Token Discount
                                      </div>
                                      <div className="text-white small">
                                        ${projectDetails?.tokenDiscount}
                                      </div>
                                    </div>
                                    <div>
                                      <div className="text-light-grey small">
                                        Total Supply
                                      </div>
                                      <div className="text-white small">
                                        {projectDetails?.totalSupply}
                                      </div>
                                    </div>
                                  </div>
                                </Card.Body>
                                <hr className="my-1" />
                                <Card.Body className="position-relative pb-0">
                                  <Row>
                                    <Col lg={6} className="mb-3">
                                      <div>
                                        {tokenomicsData.length > 0 &&
                                          <Piechart tokenomicsData={tokenomicsData} />
                                        }
                                      </div>
                                    </Col>
                                    <Col lg={6} className="mb-3">
                                      <div className="tabStyle">
                                        <Table responsive className="mb-0">
                                          <thead>
                                            <tr>
                                              <th>Details</th>
                                              <th>%(Ptg.)</th>
                                              <th>Token Quantity</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {tokenomicsData.map((row, index) => (
                                              <tr key={index}>
                                                <td>{row.detail}</td>
                                                <td>{row.percentage}%</td>
                                                <td>{row.quantity}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </Table>
                                      </div>
                                    </Col>
                                  </Row>
                                </Card.Body>
                              </Tab.Pane>
                            </Tab.Content>
                          </Col>
                        </Row>
                      </Tab.Container>
                    </div>
                  </Card>
                </Col>
                <Col xxl={4} xl={4} className="mb-4">
                  <Card className="dashboard-card gap-0 overflow-hidden bg-grey">
                    <Card.Header className="text-center">
                      Join the Community
                    </Card.Header>
                    <Card.Body className=" position-relative">
                      <p className="small text-light-grey">
                        Keep up with the Axverse project & it’s progress in
                        their telegram community channel
                      </p>

                      <div className="text-center mt-4">
                        <Link to={projectDetails?.socials} target="_blank">
                          <Button
                            variant="outline-blue"
                            className=" px-4 small mb-4"
                          >
                            <span className="me-1">
                              <img
                                src="assets/images/dashboard/icon/telegram.png"
                                width={`20px`}
                                height={`20px`}
                              />{" "}
                            </span>
                            Join the community
                          </Button>
                        </Link>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
            <br />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectOverview;
